'use client';
import React from 'react';

import styled from '@benzinga/themetron';

import { Text } from '@benzinga/core-ui';
import { sanitizeHTML } from '@benzinga/frontend-utils';

export const DisclosureBox: React.FC<{ disclosure: string }> = ({ disclosure }) => {
  const letterCount = disclosure.length;
  const [lineCount, setLineCount] = React.useState(2);

  const showMore = () => {
    if (letterCount > 85) {
      setLineCount(99);
    }
  };
  const showLess = () => {
    if (letterCount > 85 && lineCount === 99) {
      setLineCount(2);
    }
  };
  return (
    <Disclosure className="disclosure-box">
      <Text
        className="disclosure-text"
        dangerouslySetInnerHTML={{
          __html: `Disclosure: ${sanitizeHTML(disclosure)}`,
        }}
        lines={lineCount}
      />
      <div className="text-right">
        {letterCount > 85 && lineCount !== 99 && (
          <button className="text-blue-500" onClick={() => showMore()}>
            Show More{' '}
          </button>
        )}
        {lineCount === 99 && (
          <button className="text-blue-500" onClick={() => showLess()}>
            Show Less{' '}
          </button>
        )}
      </div>
    </Disclosure>
  );
};

export default DisclosureBox;

const Disclosure = styled.div`
  color: ${({ theme }) => theme.colors.foregroundMuted};
  font-size: ${({ theme }) => theme.fontSize.sm};
  padding: 0 1rem;
  margin-bottom: 1rem;
  .tip-txt {
    margin-right: 4px;
  }
  .disclosure-button {
    margin-right: 4px;
  }
  .disclosure-text {
    text-align: left;
    margin-top: 0.25rem;
  }
`;
